export const inputCls = "mt-2 w-full bg-black/40 border border-white/10 rounded px-3 py-2 text-sm font-mono focus:border-amber-500/60 outline-none transition-colors";

export const Field = ({ k, l, t, s, set }) => (
  <label className="block">
    <span className="text-xs tracking-widest text-slate-500">{l}</span>
    <input type={t} value={s[k] ?? ""} onChange={(e) => set({ ...s, [k]: e.target.value })} data-testid={`settings-${k}-input`} className={inputCls} />
  </label>
);

export const Section = ({ title, children }) => (
  <section className="space-y-5">
    <h2 className="font-display text-xl text-amber-100">{title}</h2>
    {children}
  </section>
);

export const Grid = ({ fields, s, set }) => (
  <div className="grid sm:grid-cols-2 gap-5">{fields.map(([k, l, t]) => <Field key={k} k={k} l={l} t={t} s={s} set={set} />)}</div>
);
